import gql from 'graphql-tag';
import client from '../../client';
import { INVENTORY_FIELDS } from '../fragments/inventoryFields';
import { PRODUCT_FIELDS } from '../fragments/productFields';
export const CHANGE_MEMBERSHIP = gql `
  ${INVENTORY_FIELDS}
  ${PRODUCT_FIELDS}

  mutation ChangeMembership($input: MembershipInput!, $userId: String!) {
    changeMembership(input: $input, userId: $userId)
    @rest(type: "Subscription", path: "admin/subscription/{args.userId}", method: "PATCH") {
      data {
        id
        userId
        paymentMethodId
        type
        status
        context
        canceledAt
        renewalAt
        createdAt
        updatedAt
      }
    }
  }
`;
// Mutation to change a membership
export const changeMembership = (userId, input) => {
    return client.mutate({
        mutation: CHANGE_MEMBERSHIP,
        variables: {
            userId,
            input,
        },
    });
};
export default changeMembership;
